import React, { forwardRef } from "react";
import { InputAdornment, TextFieldProps } from "@mui/material";
import { StyledInput } from "./index.styles";
import { SearchNormal } from "../../utils";

export const SearchInput = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ placeholder = "Search", value, ...rest }, ref) => {
    return (
      <StyledInput
        inputRef={ref}
        type="search"
        value={value}
        placeholder={placeholder}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position={"start"}>
                <img src={SearchNormal} />
              </InputAdornment>
            ),
          },
        }}
        {...rest}
      />
    );
  },
);

export default SearchInput;
